module.exports = __webpack_public_path__ + "img/patent_image9.f0bfefa7.png";